module.exports = __webpack_public_path__ + "img/logo.8c266817.webp";